import IComponent from "components/commons/IComponent";
import "../DetailPanels.scoped.css"

class MultiValueTable extends IComponent {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() { 
    return (<div>
      <table className="ResultInfoRowMultiValueTable">
          <thead>
            <tr className="ResultInfoRow">
              {
                this.props.data.multiValueTableSpec.map((i, j)=>{ 
                  return (<td key={`detailSlopePart_h_` + j}>{i.alias}</td>)
                })
              }
            </tr>
          </thead>
          <tbody>
            {this.props.data.multiValueTableSpec[0].value.length>0?this.props.data.multiValueTableSpec[0].value.map((k, row_index) => { 
              return (<tr key={`dataPart_r_` + row_index} className="ResultInfoRow">
                { 
                  this.props.data.multiValueTableSpec.map((c, col_index) => { 
                    return (<td key={`dataPart_r_` + row_index + "_" + col_index}>
                      {typeof c.field === "string" ? c.value[row_index] : c.value[row_index].map((cf,subRow_index) => { 
                        return (<div className="subRow" key={`dataPart_r_` + row_index + "_" + col_index + "_" + subRow_index}><span>{c.field[subRow_index].prefix+" :"}</span><span>{cf}</span></div>)
                      })}
                    </td>)
                  })
                }
              </tr>)
            }):(<tr className="ResultInfoRow"><th colSpan={this.props.data.multiValueTableSpec.length}>No data available in table</th></tr>)}
          </tbody>
        </table>        
    </div>)
  }
}
export default MultiValueTable;